module.exports = __webpack_public_path__ + "static/google-cloud-abf73415488060653766dfdaa9e1e771.png";